// TUT-505 — o `validateSearch` de `/normas`, em arquivo próprio.
//
// Não mora em `buscas.ts` de propósito: o censo das rotas de lista
// (`list-route-contract.test.ts`) anexa ao bloco da rota o ARQUIVO inteiro do
// helper e procura nele `pagina(page)` e `buscaOrdenavel(`. A consulta
// normativa não é uma lista de cadastro (não pagina, não ordena no servidor, não
// tem colunas a escolher: é uma busca de leitura com corte e contagem), e
// pôr o helper naquele arquivo a faria entrar no censo por acidente.
import { lista, texto } from "./buscas";

/**
 * O termo, os catálogos (a chave repete), a norma que o atalho da perícia e do
 * laudo manda e a edição. `edicoes` só existe ligada (`todas`): a vigente é o
 * padrão, e o padrão é a ausência da chave.
 */
export type NormasSearch = {
  q?: string;
  catalogo?: string[];
  norma?: string;
  edicoes?: "todas";
};

export function validarBuscaDeNormas(busca: Record<string, unknown>): NormasSearch {
  const { q, catalogo, norma, edicoes, ...resto } = busca;
  return {
    ...resto,
    q: texto(q),
    catalogo: lista(catalogo),
    norma: texto(norma),
    edicoes: edicoes === "todas" ? "todas" : undefined,
  } as NormasSearch;
}
